import { defineComponent as n, openBlock as a, createBlock as t, unref as l, mergeProps as i, withCtx as d, createElementVNode as p } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const s = /* @__PURE__ */ n({
  name: "IconVideoCameraInSquareFilled",
  __name: "IconVideoCameraInSquareFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (u, e) => (a(), t(l(m), i(r, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M18 3.25A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18V6A2.75 2.75 0 0 1 6 3.25h12M7.75 9.146A.75.75 0 0 0 7 9.896v4.677a.75.75 0 0 0 .75.75h5.912a.75.75 0 0 0 .75-.75v-1.14l1.946 1.191a.75.75 0 0 0 1.142-.64v-3.499a.75.75 0 0 0-1.142-.64l-1.946 1.192v-1.14a.75.75 0 0 0-.75-.75H7.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
